import React from "react";
import { Routes, Route } from "react-router-dom";
import LayoutProductos from "./LayoutProductos";
import ListaProductos from "./listaProductos";
import FormularioProducto from "./formularioProductos";
import Productos from "./productos";
import FormularioEditarProducto from "./formularioEditarProductos";
import ListaBodegas from "./listaBodegas";
import PosLayout from "./pos/posLayout";
import ListaCategoria from "./listaCategorias"

function RutasProductos() {
    return (
        <Routes>
            <Route path="/" element={<LayoutProductos />}>
                <Route index element={<ListaProductos />} />
                <Route path="agregar" element={<FormularioProducto />} />
                <Route path="bodegas" element={<ListaBodegas />} />
                <Route path="pos" element={<PosLayout />} />
                <Route path="categorias" element={<ListaCategoria />} />
                <Route path="editar/:id" element={<FormularioEditarProducto />} />
                <Route path=":id" element={<Productos />} />
            </Route>
        </Routes>
    );
}

export default RutasProductos;